import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { HostStripeMessageSchema, stripeBridgeEvent } from "@froppio/host-auth";
import { authService } from "@/core/auth/services/authService";
import { subscriptionKeys } from "../hooks/subscriptionQueries";

/** Stripe-hosted billing finishes outside the app; refresh the plan whenever the user comes back. */
export function SubscriptionHostRefresh({ businessId }: { businessId: string }) {
  const queryClient = useQueryClient();
  useEffect(() => {
    const refresh = () => void queryClient.invalidateQueries({ queryKey: subscriptionKeys.detail(businessId) });
    const receive = (event: Event) => {
      if (authService.kind !== "host" || !(event instanceof CustomEvent)) return;
      const parsed = HostStripeMessageSchema.safeParse(event.detail);
      if (parsed.success && (parsed.data.type === "resume" || parsed.data.type === "return")) refresh();
    };
    const visible = () => { if (document.visibilityState === "visible") refresh(); };
    window.addEventListener(stripeBridgeEvent, receive);
    window.addEventListener("focus", refresh);
    window.addEventListener("pageshow", refresh);
    document.addEventListener("visibilitychange", visible);
    return () => {
      window.removeEventListener(stripeBridgeEvent, receive);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("pageshow", refresh);
      document.removeEventListener("visibilitychange", visible);
    };
  }, [businessId, queryClient]);
  return null;
}
